import { createTheme } from "@mui/material/styles";
import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css"; // Regular weight
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
  },
});

export default theme;
